import axios from "axios";

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;

// Save wellness campaign response
export const saveWellnessCampaign = async (payload) => {
    try {
        const response = await axios.post(
            `${API_BASE_URL}/wellness-campaign/responses`,
            payload
        );

        return response.data;
    } catch (error) {
        throw error;
    }
};

// Get wellness campaign day completion status
export const getWellnessCampaignStatus = async (userId, accountId) => {
    try {
        const response = await axios.get(
            `${API_BASE_URL}/wellness-campaign/responses`,
            {
                params: {
                    user_id: userId,
                    account_id: accountId,
                },
            }
        );

        return response.data;
    } catch (error) {
        throw error;
    }
};